module.exports = __webpack_public_path__ + "static/home_galeria_2-8a4a62724411cc95996a917ffb53252e.jpg";